var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300.000000pt",
    height: "300.000000pt",
    viewBox: "0 0 300.000000 300.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,300.000000) scale(0.100000,-0.100000)",
    fill: "#00000060",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2248 2383 c-235 -235 -429 -425 -430 -423 -2 3 -19 37 -37 75 -71 143 -237 273 -397 311 -101 24 -257 15 -346 -19 -142 -55 -260 -158 -327 -286 -35 -69 -46 -100 -65 -182 -4 -21 -19 -31 -76 -53 -226 -89 -380 -316 -380 -561 1 -226 116 -423 312 -533 l48 -27 -180 -181 c-174 -174 -180 -182 -180 -221 0 -56 37 -93 94 -93 l41 0 1242 1243 1243 1242 0 41 c0 57 -37 94 -94 94 -40 0 -44 -4 -468 -427z m-945 -213 c169 -27 299 -143 343 -305 l17 -67 -479 -479 c-263 -263 -486 -479 -494 -479 -8 0 -40 12 -70 26 -152 71 -240 207 -240 374 0 98 20 164 73 242 57 82 138 138 243 166 102 28 117 44 132 151 15 106 52 182 121 252 76 75 162 114 286 128 6 0 36 -3 68 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2215 1815 c-18 -17 -25 -35 -25 -62 1 -59 24 -80 114 -105 105 -28 187 -84 243 -166 53 -78 73 -144 73 -242 0 -208 -144 -376 -351 -409 -38 -7 -264 -11 -557 -11 l-493 0 -24 -26 c-35 -37 -34 -92 1 -128 l27 -26 534 0 c455 0 544 2 597 16 171 44 313 159 395 321 114 227 68 505 -113 688 -79 80 -134 116 -234 151 -91 32 -155 32 -187 -1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudGrey);
export default __webpack_public_path__ + "static/media/cloud_grey.54185a5cb58954d47d7a200e1d47e2b5.svg";
export { ForwardRef as ReactComponent };